"use client";

import { useState } from 'react';

export default function HospitalityDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'EXECUTIVE DASHBOARD',
      subtitle: 'Hospitality Executive Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Hospitality Executive Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards Row */}
          {[
            { x: 16, label: 'RevPAR', value: '₹4,850', sub: '+12.4% YoY', color: '#1B2845' },
            { x: 186, label: 'Occupancy Rate', value: '78%', sub: 'Target: 82%', color: '#C5A572' },
            { x: 356, label: 'Avg Guest CLV', value: '₹28,400', sub: '+8.1% vs last yr', color: '#16a34a' },
            { x: 526, label: 'Properties', value: '24', sub: '18 above target', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Revenue per Property Bar Chart */}
          <rect x="16" y="136" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Revenue per Property</text>
          {[
            { label: 'Mumbai Grand', val: 190, color: '#1B2845' },
            { label: 'Delhi Palace', val: 155, color: '#C5A572' },
            { label: 'Goa Resort', val: 130, color: '#3b82f6' },
            { label: 'Bangalore Suites', val: 105, color: '#8b5cf6' },
            { label: 'Chennai Inn', val: 80, color: '#10b981' },
          ]?.map((bar, i) => (
            <g key={i}>
              <text x="28" y={175 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar?.label}</text>
              <rect x="120" y={163 + i * 24} width={bar?.val} height="14" fill={bar?.color} rx="2" opacity="0.85" />
              <text x={126 + bar?.val} y={175 + i * 24} fill="#374151" fontSize="9" fontFamily="sans-serif">₹{bar?.val}Cr</text>
            </g>
          ))}

          {/* Booking Channel Mix Donut */}
          <rect x="358" y="136" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Booking Channel Mix</text>
          <circle cx="470" cy="230" r="55" fill="none" stroke="#1B2845" strokeWidth="22" strokeDasharray="138 207" strokeDashoffset="0" />
          <circle cx="470" cy="230" r="55" fill="none" stroke="#C5A572" strokeWidth="22" strokeDasharray="83 262" strokeDashoffset="-138" />
          <circle cx="470" cy="230" r="55" fill="none" stroke="#3b82f6" strokeWidth="22" strokeDasharray="55 290" strokeDashoffset="-221" />
          <circle cx="470" cy="230" r="55" fill="none" stroke="#10b981" strokeWidth="22" strokeDasharray="69 276" strokeDashoffset="-276" />
          <text x="470" y="226" textAnchor="middle" fill="#1B2845" fontSize="14" fontWeight="bold" fontFamily="sans-serif">Channel</text>
          <text x="470" y="240" textAnchor="middle" fill="#6b7280" fontSize="9" fontFamily="sans-serif">Mix</text>
          {[
            { color: '#1B2845', label: 'Direct', pct: '40%' },
            { color: '#C5A572', label: 'OTA', pct: '30%' },
            { color: '#3b82f6', label: 'Corporate', pct: '20%' },
            { color: '#10b981', label: 'Groups', pct: '10%' },
          ]?.map((item, i) => (
            <g key={i}>
              <rect x="548" y={163 + i * 22} width="10" height="10" rx="2" fill={item?.color} />
              <text x="562" y={173 + i * 22} fill="#374151" fontSize="9" fontFamily="sans-serif">{item?.label}: {item?.pct}</text>
            </g>
          ))}

          {/* Occupancy Trend Line */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Occupancy Rate Trend (%)</text>
          <polyline points="50,395 130,385 210,375 290,380 370,365 450,355 530,360 620,345 680,338" fill="none" stroke="#C5A572" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="50,395 130,385 210,375 290,380 370,365 450,355 530,360 620,345 680,338 680,400 50,400 Z" fill="#C5A572" opacity="0.06" />
          {[50,130,210,290,370,450,530,620,680]?.map((x, i) => (
            <circle key={i} cx={x} cy={[395,385,375,380,365,355,360,345,338]?.[i]} r="3" fill="#1B2845" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep']?.map((m, i) => (
            <text key={i} x={[50,130,210,290,370,450,530,620,680]?.[i] - 8} y="408" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}
        </svg>
      ),
    },
    {
      title: 'REVENUE MANAGEMENT DASHBOARD',
      subtitle: 'Demand & Pricing Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Revenue Management Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Occupancy Forecast', value: '82%', sub: 'Next 30 days', color: '#C5A572' },
            { x: 186, label: 'ADR', value: '₹6,200', sub: '+5.8% vs LY', color: '#1B2845' },
            { x: 356, label: 'RevPAR Index', value: '112.4', sub: 'Above market', color: '#16a34a' },
            { x: 526, label: 'Demand Score', value: 'High', sub: 'Weekend peak', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Demand Forecasting Line Chart */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Demand Forecasting (Next 30 Days)</text>
          <polyline points="30,290 80,270 130,260 180,240 230,250 280,220 330,210 380,200 420,195" fill="none" stroke="#1B2845" strokeWidth="2" strokeLinecap="round" />
          <polyline points="30,295 80,278 130,268 180,250 230,262 280,232 330,222 380,212 420,207" fill="none" stroke="#C5A572" strokeWidth="1.5" strokeDasharray="4 3" strokeLinecap="round" />
          <polyline points="30,285 80,262 130,252 180,230 230,238 280,208 330,198 380,188 420,183" fill="none" stroke="#C5A572" strokeWidth="1.5" strokeDasharray="4 3" strokeLinecap="round" />
          <polyline points="30,290 80,270 130,260 180,240 230,250 280,220 330,210 380,200 420,195 420,310 30,310 Z" fill="#1B2845" opacity="0.04" />
          {['W1','W2','W3','W4']?.map((w, i) => (
            <text key={i} x={80 + i * 100} y="308" fill="#9ca3af" fontSize="8" textAnchor="middle" fontFamily="sans-serif">{w}</text>
          ))}

          {/* Channel Performance Bars */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Channel Performance</text>
          {[
            { label: 'Direct', val: 160, color: '#1B2845', rev: '₹48Cr' },
            { label: 'OTA', val: 120, color: '#C5A572', rev: '₹36Cr' },
            { label: 'GDS', val: 80, color: '#3b82f6', rev: '₹24Cr' },
            { label: 'Corporate', val: 100, color: '#10b981', rev: '₹30Cr' },
          ]?.map((bar, i) => (
            <g key={i}>
              <text x="460" y={178 + i * 30} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar?.label}</text>
              <rect x="510" y={166 + i * 30} width={bar?.val} height="14" fill={bar?.color} rx="2" opacity="0.8" />
              <text x="516" y={178 + i * 30} fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">{bar?.rev}</text>
            </g>
          ))}

          {/* Pricing Heatmap */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Dynamic Pricing Heatmap (Room Rate by Day)</text>
          {['Mon','Tue','Wed','Thu','Fri','Sat','Sun']?.map((day, i) => {
            const rates = [4200, 4400, 4300, 4600, 5800, 7200, 6500];
            const maxRate = 7200;
            const intensity = rates?.[i] / maxRate;
            const r = Math.round(27 + (197 - 27) * intensity);
            const g = Math.round(40 + (165 - 40) * intensity);
            const b = Math.round(69 + (114 - 69) * intensity);
            return (
              <g key={i}>
                <rect x={28 + i * 92} y="354" width="82" height="40" rx="4" fill={`rgb(${r},${g},${b})`} opacity="0.8" />
                <text x={69 + i * 92} y="370" textAnchor="middle" fill="white" fontSize="8" fontFamily="sans-serif">{day}</text>
                <text x={69 + i * 92} y="384" textAnchor="middle" fill="white" fontSize="9" fontWeight="bold" fontFamily="sans-serif">₹{rates?.[i]?.toLocaleString()}</text>
              </g>
            );
          })}
        </svg>
      ),
    },
    {
      title: 'OPERATIONS DASHBOARD',
      subtitle: 'Property Operations Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Operations Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Service Score', value: '94/100', sub: '+2.1 pts MoM', color: '#16a34a' },
            { x: 186, label: 'Op Efficiency', value: '88%', sub: 'Target: 90%', color: '#C5A572' },
            { x: 356, label: 'Maintenance Open', value: '12', sub: '3 high priority', color: '#dc2626' },
            { x: 526, label: 'Staff Productivity', value: '91%', sub: 'Above benchmark', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Staff Productivity by Department */}
          <rect x="16" y="136" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Staff Productivity by Department</text>
          {[
            { label: 'Front Desk', val: 175, color: '#1B2845', pct: '95%' },
            { label: 'Housekeeping', val: 155, color: '#C5A572', pct: '91%' },
            { label: 'F&B', val: 145, color: '#3b82f6', pct: '88%' },
            { label: 'Concierge', val: 160, color: '#10b981', pct: '93%' },
            { label: 'Maintenance', val: 130, color: '#8b5cf6', pct: '82%' },
          ]?.map((bar, i) => (
            <g key={i}>
              <text x="28" y={175 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar?.label}</text>
              <rect x="110" y={163 + i * 24} width={bar?.val} height="14" fill={bar?.color} rx="2" opacity="0.8" />
              <text x="116" y={175 + i * 24} fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">{bar?.pct}</text>
            </g>
          ))}

          {/* Maintenance Alerts */}
          <rect x="358" y="136" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Maintenance Alerts</text>
          {[
            { item: 'HVAC Unit — Floor 8', priority: 'HIGH', color: '#dc2626', bg: '#fef2f2' },
            { item: 'Pool Pump — Goa Resort', priority: 'HIGH', color: '#dc2626', bg: '#fef2f2' },
            { item: 'Elevator — Tower B', priority: 'MED', color: '#d97706', bg: '#fffbeb' },
            { item: 'Lighting — Lobby', priority: 'MED', color: '#d97706', bg: '#fffbeb' },
            { item: 'Plumbing — Room 412', priority: 'LOW', color: '#16a34a', bg: '#f0fdf4' },
          ]?.map((alert, i) => (
            <g key={i}>
              <rect x="370" y={163 + i * 28} width="302" height="22" rx="4" fill={alert?.bg} />
              <text x="380" y={178 + i * 28} fill="#374151" fontSize="9" fontFamily="sans-serif">{alert?.item}</text>
              <rect x="630" y={165 + i * 28} width="32" height="18" rx="3" fill={alert?.color} opacity="0.15" />
              <text x="646" y={178 + i * 28} textAnchor="middle" fill={alert?.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{alert?.priority}</text>
            </g>
          ))}

          {/* Property Performance Table */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Property Performance Comparison</text>
          <line x1="16" y1="352" x2="684" y2="352" stroke="#e5e7eb" strokeWidth="1" />
          {['Property', 'Occupancy', 'RevPAR', 'Satisfaction', 'Status']?.map((h, i) => (
            <text key={i} x={28 + i * 130} y="364" fill="#6b7280" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{h}</text>
          ))}
          {[
            ['Mumbai Grand', '82%', '₹5,100', '4.8/5', '✓'],
            ['Delhi Palace', '76%', '₹4,700', '4.6/5', '✓'],
            ['Goa Resort', '91%', '₹6,200', '4.9/5', '✓'],
          ]?.map((row, i) => (
            <g key={i}>
              {row?.map((cell, j) => (
                <text key={j} x={28 + j * 130} y={380 + i * 14} fill={j === 4 ? '#16a34a' : '#374151'} fontSize="9" fontFamily="sans-serif">{cell}</text>
              ))}
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Hospitality Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">Real-time dashboards built for every decision-maker in your hospitality organization.</p>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards?.map((dashboard, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`px-6 py-3 rounded-lg font-semibold text-sm transition-all duration-300 ${
                activeTab === index
                  ? 'bg-navy text-white shadow-lg'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/40 hover:shadow-md'
              }`}
            >
              {dashboard?.title}
            </button>
          ))}
        </div>

        {/* Dashboard Display */}
        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-lg">
          <div className="mb-4">
            <h3 className="font-serif text-navy text-xl font-bold">{dashboards?.[activeTab]?.title}</h3>
            <p className="text-charcoal/60 text-sm">{dashboards?.[activeTab]?.subtitle}</p>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards?.[activeTab]?.svg}
          </div>
        </div>
      </div>
    </section>
  );
}
